import React, { ReactNode } from 'react';

import * as S from './styles';

interface IGridProps {
  children: ReactNode;
  className?: string;
  style?: object;
}

interface IItemProps {
  /** The field name. Rendered as the design's uppercase `dt`. */
  label: ReactNode;
  children?: ReactNode;
  /** Spans every column. For prose, or a value that needs the room. */
  wide?: boolean;
  /** Reading line-height and regular weight, for a description or a note. */
  prose?: boolean;
  className?: string;
}

/**
 * The design's detail grid.
 *
 *   <PanelBoxLayout className="flush" contentStyle={{ padding: 0 }} ...>
 *     <DetailGrid>
 *       <DetailItem label="Employee ID"><Value mono>{user.id}</Value></DetailItem>
 *       <DetailItem label="Description" wide prose>{ticket.description}</DetailItem>
 *     </DetailGrid>
 *   </PanelBoxLayout>
 *
 * The card **must** be `flush`: the grid hangs its outer hairlines a pixel
 * past its own box and relies on the card's `overflow: hidden` to cut them.
 */
const DetailGrid: React.FC<IGridProps> = ({ children, className, style }) => (
  <S.Grid className={className} style={style}>
    {children}
  </S.Grid>
);

export const DetailItem: React.FC<IItemProps> = ({ label, children, wide, prose, className }) => (
  <S.Item className={`${wide ? 'wide' : ''} ${className || ''}`.trim()}>
    <S.Label>{label}</S.Label>
    <S.Data className={prose ? 'prose' : ''}>{children}</S.Data>
  </S.Item>
);

export default DetailGrid;
